import { createFileRoute } from "@tanstack/react-router";

import { AdminPage } from "../admin/AdminPage";
import { adminSettingsQueryOptions } from "../admin/queries";

export const Route = createFileRoute("/_auth/admin")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(adminSettingsQueryOptions).catch(() => undefined),
  component: AdminPage,
});
